import { Injectable } from '@angular/core';
import { TransferConnectV2SettingService } from '@features/transfer-connect-v2/services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';
import { TransactionDetailsFormatterService } from '@rd/core/services/transaction-details-formatter/transaction-details-formatter.service';
import { LoyaltyProgramHelper } from '@rd/helpers/loyalty-program.helper';
import { DynamicListItem } from '@rd/shared-legacy/components/dynamic-list/dynamic-list-item.type';
import {
  LoyaltyProgram,
  LoyaltyProgramCategory,
  PointsTransferMembership,
} from '@rd/types';

@Injectable({
  providedIn: 'root',
})
export class BnzTransactionDetailsFormatterService extends TransactionDetailsFormatterService {
  constructor(loyaltyProgramHelper: LoyaltyProgramHelper) {
    super(loyaltyProgramHelper);
  }

  pointsTransferDetailsFormat(params: {
    loyaltyProgram: LoyaltyProgram;
    pointsTransferData: Partial<PointsTransferMembership>;
    processingDelay: number;
    tcv2Settings?: TransferConnectV2SettingService;
  }): DynamicListItem[] {
    const {
      loyaltyProgram,
      pointsTransferData,
      processingDelay,
      tcv2Settings,
    } = params;

    const isVoucherLoyaltyProgram =
      loyaltyProgram.category === LoyaltyProgramCategory.Voucher;

    const memberDetailsItemsWithoutDob: DynamicListItem[] = [
      {
        translationKey:
          // [Hau]: special case for voucher loyalty programs
          // we should show the simplified title for voucher loyalty programs
          // For now, only BNZ has voucher loyalty program which is Uber
          isVoucherLoyaltyProgram
            ? 'transfer_v2.review.membership_details_title_simplified'
            : 'transfer_v2.review.membership_details_title',
        htmlTag: 'p',
        cssClass: 'membership-details-title',
        value: {
          loyaltyProgramName: loyaltyProgram.name,
          ...(!isVoucherLoyaltyProgram && {
            redeemDuration:
              this.loyaltyProgramHelper.getRedeemDurationText(processingDelay),
          }),
        },
      },
      {
        translationKey: pointsTransferData.number,
        htmlTag: 'p',
        cssClass: 'membership-details-information',
      },
      {
        translationKey: `${pointsTransferData.firstName} ${pointsTransferData.lastName}`,
        htmlTag: 'p',
        cssClass: 'membership-details-information',
      },
    ];

    return tcv2Settings?.shouldShowDobFieldInLinkForm(
      loyaltyProgram.transferConnectIdentifier as string,
    )
      ? [
          ...memberDetailsItemsWithoutDob,
          ...this.getDateOfBirth(pointsTransferData),
        ]
      : [...memberDetailsItemsWithoutDob];
  }
}
